import Proxy from './Proxy';

class MessageProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/PatientMessages', parameters);
  }

  /**
   * Method used to fetch patients.
   *
   * @returns {Promise} The result in a promise.
   */
  fetchPatients(filter) {
    return this.submit('post', `${this.endpoint}/list`, filter);
  }

  /**
   * Method used to fetch messages of a particular patients.
   *
   * @param {id} patientId
   * @returns {Promise} The result in a promise.
   */
  fetchPatientMessages({ id, filter }) {
    return this.submit('post', `${this.endpoint}/${id}`, filter);
  }

  /**
   * Method used to fetch messages of a particular patients.
   *
   * @param {id} patientId
   * @returns {Promise} The result in a promise.
   */
  getRoomId({ patientId }) {
    return this.submit('post', `/Patients/initiateVideoCall`, { patientId });
  }

  closeVideoChat({ room_id }) {
    return this.submit('post', `/Patients/completeVideoCall`, { room_id: room_id });
  }

  saveVideoCallNotes({ description, patient_id, care_navigator_id, video_call_id }) {
    return this.submit('post', `/PatientVideoNotes`, { description, patient_id, care_navigator_id, video_call_id });
  }

  /**
   * Sends message to the patient.
   *
   * @param {Object} data
   * @returns {Promise} The result in a promise.
   */
  sendMessage(data) {
    return this.submit('post', this.endpoint, data);
  }
}

export default MessageProxy;
